(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('IntegrityWarningDialogController', IntegrityWarningDialogController);

    IntegrityWarningDialogController.$inject = ['$uibModalInstance', 'failedFiles', 'onProceed'];

    function IntegrityWarningDialogController($uibModalInstance, failedFiles, onProceed) {
        var vm = this;

        vm.failedFiles = failedFiles;
        vm.userAcknowledged = false;
        vm.cancel = cancel;
        vm.proceed = proceed;
        vm.getStatusTranslationKey = getStatusTranslationKey;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function proceed() {
            if (vm.userAcknowledged) {
                if (onProceed && typeof onProceed === 'function') {
                    onProceed();
                }
                $uibModalInstance.close('proceed');
            }
        }

        /**
         * Returns the translation key for the file's validation status message.
         * Maps backend messages to i18n keys.
         */
        function getStatusTranslationKey(file) {
            var message = file.checksumValidationMessage || '';
            var baseKey = 'eDocumentsApp.digitalArchive.integrityWarning.';

            if (message.indexOf('modified') !== -1 || message.indexOf('modified since archival') !== -1) {
                return baseKey + 'fileModified';
            } else if (message.indexOf('not found') !== -1 || message.indexOf('File not found') !== -1) {
                return baseKey + 'fileNotFound';
            } else if (message.indexOf('Error') !== -1 || message.indexOf('error') !== -1) {
                return baseKey + 'validationError';
            } else {
                return baseKey + 'fileModified'; // Default for checksum failures
            }
        }
    }
})();
